<template>
  <div id="entradas-consolidacao" class="w3-container w3-margin-top" style="">
    <div class="w3-col s12 m12 l12 w3-margin-bottom" v-if="processando">
      <div class="w3-panel w3-theme w3-card-2">
        <p><i class="fa fa-sync-alt w3-spin"></i> Processando...</p>
      </div>
    </div>

    <div v-if="!processando" class="w3-margin-bottom">
      <input
        class="w3-input w3-border w3-padding margin-bottom-filtro"
        type="text"
        placeholder="Pesquise por nome ou código"
        v-model="filtro"
        v-on:keyup="filtrarEntradas()">
    </div>

    <div
      class="w3-panel w3-text-theme w3-bottombar w3-border-theme w3-border w3-animate-left"
      v-if="!processando && ((!entradas_filtradas) || (entradas_filtradas.length == 0))"
      v-cloak>
      <div class="w3-container w3-white">
        <p>Não há entradas a serem exibidas.</p>
      </div>
    </div>

    <div
      class="wrapper-componente"
      v-if="!processando && (entradas_filtradas) && (entradas_filtradas.length > 0)">

      <div
        class="card-item w3-container"
        v-for="(entrada, entrada_index) in novasEntradasFiltradas"
        :key="entrada_index"
        @click="mostrarDetalhes(entrada, !entrada.mostrar_detalhes)">
        
        <div class="w3-col s12">
          <strong class="w3-left"></strong>
            <legenda>
              <strong>Entrada e valor</strong>
              <i slot="referencia" class="fas fa-shopping-basket w3-text-theme"></i>&nbsp;
            </legenda>
            <strong class="w3-text-theme">{{entrada.entrada_id}}</strong>
            <strong class="w3-text-green w3-right">R$ {{entrada.valor_nota}}</strong>
          </strong>
        </div>
        
        <div class="w3-col s12">
          <strong class="w3-left"></strong>
            <legenda>
              <strong>Data entrada</strong>
              <i slot="referencia" class="far fa-calendar-alt w3-text-theme"></i>&nbsp;
            </legenda>
            <label>{{entrada.data_entrada}}</label>
          </strong>
        </div>
        
        <div class="w3-col s12">
          <strong class="w3-left"></strong>
            <legenda>
              <strong>Fornecedor</strong>
              <i slot="referencia" class="far fa-handshake w3-text-theme"></i>&nbsp;
            </legenda>
            <strong>{{entrada.nome_fornecedor}}</strong>
          </strong>
        </div>
        
        <div class="w3-col s12">
          <strong class="w3-left"></strong>
            <legenda>
              <span>Empresa</span>
              <i slot="referencia" class="fas fa-building  w3-text-theme"></i>&nbsp;
            </legenda>
            <label>{{entrada.nome_empresa}}</label>
          </strong>
        </div>

        <div class="w3-col s12">
          <label>Número da nota: </label>
          <strong>{{entrada.numero_nota}}</strong>
        </div>

        <div class="w3-col s12">
          <label>Status Analítico: </label>
          <strong>{{entrada.status_analitico}}</strong>
        </div>

        <transition name="fade" mode="out-in">
          <div v-if="entrada.mostrar_detalhes">
            <div class="mapa-financeiro-card">
              <modal-entradas-sem-estoque-consolidado
                :consolidar="true"
                :status="entrada.status_analitico"
                :entrada_id="entrada.entrada_id">
              </modal-entradas-sem-estoque-consolidado>
            </div>
          </div>
        </transition>
      </div>

      <paginacao
        @pagina="mudarPagina"
        :pagina-atual="pagina_atual"
        :itens-por-pagina="itens_por_pagina"
        :total-resultados="total_resultados"
        :total-de-paginas="total_paginas"/>
    </div>

  </div>
</template>

<script>
  import toastr from 'toastr'
  import legenda from '@/components/Legendas'
  import Paginacao from '@/components/Paginacao'
  import REntradaBuscarEntradasSemFinanceiroConsolidadoDashboard from '@/components/Rest/REntrada/REntradaBuscarEntradasSemFinanceiroConsolidadoDashboard.js'
  import ModalEntradasSemEstoqueConsolidado from '@/components/Dashboard/ModalEntradasSemEstoqueConsolidado.vue'

  export default {
    name: 'EntradasSemFinanceiroConsolidado',

    components: {
      Paginacao,
      ModalEntradasSemEstoqueConsolidado,
      legenda
    },

    data() {
      return {
        processando: false,
        filtro: '',
        entradas_filtradas: [],
        entradas_consolidacao: [],

        pagina_atual: 0,
        total_paginas: 0,
        total_resultados: 0,
        itens_por_pagina: 10
      }
    },
    
    mounted() {
      $('html,body').stop().animate(
        {scrollTop: 0}, 
        'slow', 
        'swing'
      );
    },

    methods: {
      mudarPagina(numero_da_pagina) {
        this.pagina_atual = numero_da_pagina;
      },
      
      filtrarEntradas() {
        this.entradas_filtradas = [];
        this.mudarPagina(0)

        if (this.filtro == '') {
          this.entradas_filtradas = this.entradas_consolidacao;
        }
        
        for (let i = 0; i < this.entradas_consolidacao.length; i++) {
          if (
            (this.entradas_consolidacao[i].nome_fornecedor.toUpperCase().indexOf(this.filtro.toUpperCase()) > -1) ||
            (this.entradas_consolidacao[i].entrada_id.replace(".", "").indexOf(this.filtro).replace(".", "") > -1)
          ) {
            this.entradas_filtradas.push(this.entradas_consolidacao[i]);
          }
        }
      },

      mostrarDetalhes(index, condicional) {
        this.$set(index, 'mostrar_detalhes', condicional)
      },

      async buscarEntradas() {
        this.processando = true;
        this.entradas_filtradas.length = 0;

        try {
          let retorno = await REntradaBuscarEntradasSemFinanceiroConsolidadoDashboard.buscarEntradasSemFinanceiroConsolidadoDashboard(this.axios);
          if (retorno.houve_erro == 'S') {
            throw new Error(retorno.mensagem);
          }

          this.entradas_consolidacao = JSON.parse(JSON.stringify(retorno.dados.entradas));
          this.entradas_filtradas = JSON.parse(JSON.stringify(retorno.dados.entradas));
          this.processando = false;
        }
        catch (error) {
          this.processando = false;
          toastr.error(error.message);
        }
      }
    },
    
    created() {
      this.buscarEntradas();
    },

    computed: {
      novasEntradasFiltradas() {
        this.total_resultados = this.entradas_filtradas.length;
        this.total_paginas =  Math.ceil(this.total_resultados / this.itens_por_pagina);
        
        if (this.pagina_atual >= this.total_paginas) { 
          this.pagina_atual = this.total_paginas;
        }
        
        let index = this.pagina_atual * this.itens_por_pagina
        return this.entradas_filtradas.slice(index, index + this.itens_por_pagina);
      }
    }
  }
</script>

<style scoped>
  .card-item {
    background: rgb(235, 235, 235);
    border-radius: 10px;
    margin-bottom: 10px;
    padding: 5px !important;
    border: 2px solid #ccc;
    box-shadow: #6b6b6b 2px 2px 5px 2px;
  }

  .tr-items:hover {
    background: #9c1d1cb8;
    color:#fff;
    cursor: pointer;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .tr-items-ativo:hover {
    background: #9c1d1cb8;
    color: white;
  }

  .tr-items-ativo {
    background: #9c1d1c;
    color: white;
  }

  .mapa-financeiro-card {
    padding: 0 !important
  }

  th {
    white-space: nowrap;
  }

  .wrapper-componente {
    overflow: auto;
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/EntradasSemFinanceiroConsolidado.vue